import {
  faIdCard,
  faGavel,
  faMapMarkerAlt,
  faBriefcase,
  faGraduationCap,
  faDatabase,
  faPrescriptionBottleAlt,
  faCreditCard,
  faUsers
} from '@fortawesome/free-solid-svg-icons';

export const IdentityArr = {
  PAN: 'PAN card',
  DL: 'Driving license',
  VOTER_ID: 'Voter ID',
  AADHAAR: 'Aadhaar',
  PASSPORT: 'Passport'
};

export const AddressArr = {
  CURRENT: 'Current address',
  PERMANENT: 'Permanent address',
  ANY_1: 'Any 1 (PERMANENT,CURRENT)',
  ANY_2: '(PERMANENT,CURRENT)'
};

export const AddressConstants = {
  ANY_1: 'ANY_1',
  ANY_2: 'ANY_2',
  PERMANENT: 'PERMANENT',
  CURRENT: 'CURRENT'
};

export const EducationArr = {
  10: '10th grade',
  12: '12th grade / Diploma',
  UG: 'Undergraduate degree',
  UNDERGRAD: 'Undergraduate degree',
  PG: 'Postgraduate degree',
  POSTGRAD: 'Postgraduate degree',
  PHD: 'PhD',
  PHD: 'PhD'
};

export const obj = {
  10: '10th grade',
  12: '12th grade / Diploma',
  UNDERGRAD: 'Undergraduate degree',
  POSTGRAD: 'Postgraduate degree',
  '12/Diploma': '12th grade / Diploma',
  Postgraduate: 'Postgraduate degree',
  UG: 'undergraduate degree',
  PG: 'postgraduate degree',
  PHD: 'PhD',
  '10th': '10th grade',
  '12th': '12th grade / Diploma',
  Graduation: 'Undergraduate degree',
  'Post Graduation': 'Postgraduate degree',
  Doctorate: 'Doctorate',
  Diploma: 'Diploma',
  Other: 'Other',
  Undergraduate: 'Undergraduate degree'
};

export const IDENTITES_FOR_PACKAGE_CONFIG = [
  { name: 'PAN', label: 'PAN' },
  { name: 'AADHAAR', label: 'Aadhaar' },
  { name: 'DL', label: 'Driving License' },
  { name: 'VOTER_ID', label: 'Voter ID' },
  { name: 'PASSPORT', label: 'Passport' }
];

export const ADDRESS_FOR_PACKAGE_CONFIG = [
  { name: 'ANY_1', label: 'Any 1 address' },
  { name: 'CURRENT', label: 'Current address' },
  { name: 'PERMANENT', label: 'Permanent address' }
];

export const PLAIN_CHECK_ICONS = {
  identity: { icon: faIdCard, title: 'Identity Verification' },
  court: { icon: faGavel, title: 'Court Record' },
  address: { icon: faMapMarkerAlt, title: 'Address Verification' },
  employment: { icon: faBriefcase, title: 'Employment Verification' },
  education: { icon: faGraduationCap, title: 'Education Verification' },
  education_official: { icon: faGraduationCap, title: 'Education Verification' },
  education_regional_partner: { icon: faGraduationCap, title: 'Education Verification' },
  education_hybrid: { icon: faGraduationCap, title: 'Education Verification' },
  world: { icon: faDatabase, title: 'World Check' },
  drug: { icon: faPrescriptionBottleAlt, title: 'Drug Check' },
  credit: { icon: faCreditCard, title: 'Cibil check' },
  reference: { icon: faUsers, title: 'Reference' }
};

export const ADDRESS_LOOPING_CONSTANT = [
  { label: 'Permanent Address', value: 'permanent_address', dataName: 'PERMANENT' },
  { label: 'Current Address', value: 'current_address', dataName: 'CURRENT' },
  { label: 'Any Address', value: 'any_address', dataName: 'ANY ADDRESS' }
];

export const DRUG_CHECK_TEXT = {
  '5_PANEL': '5 Panel',
  '7_PANEL': '7 Panel',
  '10_PANEL': '10 Panel'
};

export const EDUCATION_TYPES_FOR_PACKAGE_CONFIG = [
  { name: '10', label: '10th grade' },
  { name: '12', label: '12th grade / Diploma' },
  { name: 'UNDERGRAD', label: 'Undergraduate degree' },
  { name: 'POSTGRAD', label: 'Postgraduate degree' },
  { name: 'PHD', label: 'PhD' }
];

export const ADDRESS_FOR_ADDON_CONFIG = [
  { name: 'CURRENT', label: 'Current address' },
  { name: 'PERMANENT', label: 'Permanent address' }
];

export const COURT_OPTIONS_FOR_ADDON_CONFIG = [
  { name: 'CURRENT', label: 'Current address', id: 'court_current_add' },
  { name: 'PERMANENT', label: 'Permanent address', id: 'court_permanent_add' }
];

export const ID_DROPDOWN = {
  PAN: { label: 'PAN', value: 'ind_pan', name: 'PAN' },
  DL: { label: 'Driving License', value: 'ind_driving_license', name: 'DL' },
  PASSPORT: { label: 'Passport', value: 'ind_passport', name: 'PASSPORT' },
  VOTER_ID: { label: 'Voter ID', value: 'ind_voter_id', name: 'VOTER_ID' },
  AADHAAR: { label: 'Aadhaar', value: 'ind_aadhaar', name: 'AADHAAR' }
};

export const EDUCATION_TYPES = [
  { name: 'OFFICIAL', label: 'Official Verification' },
  { name: 'REGIONAL_PARTNER', label: 'Regional Partner Verification' },
  { name: 'HYBRID', label: 'Hybrid Verification' }
];

export const EDUCATION_TYPES_ADDONS = {
  OFFICIAL: 'education',
  REGIONAL_PARTNER: 'educationThirdParty',
  HYBRID: 'educationHybrid'
};

export const APPROVAL_STATUS = [
  { label: 'All', value: '' },
  { label: 'Pending', value: 'PENDING' },
  { label: 'Approved & Auto-approved', value: 'APPROVED' },
  { label: 'Rejected & Auto-rejected', value: 'REJECTED' },
  { label: 'Deleted & Refunded', value: 'DELETED' }
];
export const COST_TYPE = [
  { label: 'All', value: '' },
  { label: 'Pass-through fee', value: 'PASS_THROUGH' },
  { label: 'International charge', value: 'INTERNATIONAL' },
  { label: 'Re-initiation charge', value: 'RE_INITIATION' },
  { label: 'Other charge', value: 'OTHER' }
];
export const CHECKS_LIMIT = {
  ID: 5,
  ADD: 2,
  COURT: 2,
  EMP: 10,
  DRUG: 1,
  EDU: 5,
  REF: 10,
  WORLD: 1,
  CIBIL: 1
};

export const GENDER = {
  1: 'Male',
  2: 'Female',
  3: 'Other'
};

export const loggly_payment_type = {
  ADDON: 'ADDON BOUGHT',
  ADC_RECHARGE: 'ADC RECHARGE',
  CREDITS: 'CREDITS BOUGHT',
  CREATE_CANDIDATE: 'CANDIDATE ADDED',
  PACKAGE_BOUGHT: 'PACKAGE BOUGHT',
  ORDER: 'ORDER'
};

export const CANDIDATES_STATUSES = [
  { label: 'In Progress', value: 0 },
  { label: 'Completed', value: 1 },
  { label: 'Awaiting Input', value: 3 },
  { label: 'Processing', value: 4 },
  { label: 'Completed with exception', value: 6 },
  { label: 'Insufficiency', value: 7 },
  { label: 'Closed', value: 8 },
  { label: 'On Hold', value: 9 },
  { label: 'Consent Missing', value: 11 },
  { label: 'Insufficient Funds', value: 12 }
];

export const CANDIDATES_TIME_RANGE = [
  { label: 'Select', value: -1 },
  { label: 'All time', value: 1 },
  { label: 'Last 7 days', value: 7 },
  { label: 'Last 30 days', value: 30 },
  { label: 'Last 60 days', value: 60 },
  { label: 'Last 90 days', value: 90 },
  { label: 'Custom range', value: 0 }
];

export const DIGEST_FREQUENCY = [
  { label: 'Daily', value: 'DAILY' },
  { label: 'Weekly', value: 'WEEKLY' }
];

export const DIGEST_TYPE = [
  { label: 'Cases completed', value: 'CANDIDATE' },
  { label: 'Checks completed', value: 'CHECK' }
];

export const IDENTITY_TYPE = {
  1: 'Any',
  2: 'PAN Card',
  3: 'Driving Licence',
  4: 'Passport',
  5: 'Voter ID'
};

export const ICONS_VERIFICATIONS = [
  { value: 'Identity Verification', icon: 'Identity', width: 28 },
  { value: 'Employment Verification', icon: 'Employment', width: 29 },
  { value: 'Address Verification', icon: 'Address', width: 21 },
  { value: 'Education Verification', icon: 'Education', width: 35 },
  { value: 'World Verification', icon: 'World', width: 23 },
  { value: 'Drug Verification', icon: 'Drug', width: 22 },
  { value: 'Court Record Verification', icon: 'Court_Record', width: 26 },
  { value: 'CIBIL Credit Score Verification', icon: 'CIBIL_Credit_Score', width: 28 },
  { value: 'Reference Verification', icon: 'Reference', width: 30 },
  { value: 'Custom Verification', icon: 'Custom', width: 30 }
];

//TDS options for comany
export const TDS_OPTIONS = [
  { value: 'NONE', label: 'None', disable: false },
  { value: '2', label: '2%', disable: false },
  { value: '10', label: '10%', disable: false }
];

// TDS tooltip msg
export const TDS_TOOLTIP =
  'Tax Deduction at Source (TDS) is the amount of tax that is deducted from the taxpayer and is deposited to the Income Tax Department on behalf of the taxpayer.';

export const PACKAGE_UNIT_INDICATION = {
  NILL: 'NILL', // CRITICAL
  LOW: 'LOW',
  SUFFICIENT: 'SUFFICIENT'
};

export const WALLET_BALLANCE_INDICATION = {
  NILL: 'NILL', // CRITICAL
  LOW: 'LOW',
  SUFFICIENT: 'SUFFICIENT'
};

export const PACKAGE_UNIT_INDICATION_FACTOR = 0.2;
export const PASSWORD_CRITERIA = [
  'minimum 12 characters',
  'one UPPER CASE character',
  'one lower case character',
  'one number',
  'one symbol',
  'no successively repeating characters'
];

export const PHONE_NUMBER_SAMPLE = '9023402946';
export const FILLED_CHECKS = {
  identity: 'candidatesIds',
  address: 'candidatesAddresses',
  employment: 'candidatesEmployments',
  education: 'candidatesEducations',
  court: 'candidateHistories',
  world: 'candidatesWorldchecks',
  drug: 'candidateDrugs',
  reference: 'candidatesRefchecks',
  cibil: 'candidatesCreditchecks'
};

export const TRANSACTION_TYPE = {
  PURCHASE: 'Purchase (Recharge)',
  RECHARGE: 'Purchase (Recharge)',
  PACKAGE_BOUGHT: 'Purchase (Recharge)',
  FREE_CREDITS: 'Free Credits',
  FREE_CREDITS_TRIAL: 'Free Credits (Trial)',
  CREDIT_REFUND: 'Refund to Customer'
};
export const USAGE_EVENTS = {
  RECHARGE: 'Purchage (Recharge)',
  PACKAGE_BOUGHT: 'Package',
  CREDIT_NOTE: 'Credit Note',
  CREDIT_REFUND: 'Refund to Customer',
  FREE_CREDITS: 'Free Credits',
  CREDIT_DEDUCTION: 'Credit Adjustment',
  SPLIT_PURCHASE: 'Split Purchase',
  PACKAGE_UNITS_CONVERTED_TO_CREDITS: 'Package Refund',
  BRIDGE_CREDITS: 'Bridge credits',
  FREE_CREDITS_TRIAL: 'Free credits (Trial)',
  CREDIT_DEDUCTION_BRIDGE_CREDITS: 'Bridge Credits Deduction',
  CANDIDATE_ADDED: 'Candidate added',
  CANDIDATE_DELETED: 'Candidate deleted',
  DISCOUNT: 'Discount',
  PENALTY: 'Penalty',
  TRIAL: 'Trial',
  INVOICE_PAID: 'Invoice paid',
  CREDIT_LIMIT_INCREASED: 'Credit limit increased',
  CREDIT_LIMIT_DECREASED: 'Credit limit decreased',
  ADDON_BOUGHT: 'Add-on Check',
  CHECK_REFUND: 'Add-on Check Refund',
  ADDITIONAL_CHARGE: 'Additional Cost',
  ADDITIONAL_CHARGE_REFUND: 'Additional Cost Refund',
  CREDITS_LOCKED: '- Credits Locked',
  CREDITS_UNLOCKED: '+ Credits Unlocked'
};

export const ADC_TYPES = {
  PASS_THROUGH: 'Pass Through',
  INTERNATIONAL: 'International',
  RE_INITIATION: 'Re-initiation',
  OTHER: 'Other'
};
export const PAYMENT_MODE_OBJ = {
  CASH: 'Cash',
  CREDIT_CARD: 'Credit / Debit card',
  DEMAND_DRAFT: 'Demand Draft',
  CHEQUE: 'Cheque',
  NEFT_OR_UPI: 'Bank Transfer',
  PAYMENT_GATEWAY: 'Payment Gateway'
};
export const sexTypes = [
  { value: 1, label: 'Male' },
  { value: 2, label: 'Female' },
  { value: 3, label: 'Non-binary' },
  { value: 4, label: 'Prefer not to disclose' }
];
export const sexTypesObj = {
  1: 'Male',
  2: 'Female',
  3: 'Non-binary',
  4: 'Prefer not to disclose'
};

export const modelType = {
  prepaid: 'PREPAID',
  postpaid: 'POSTPAID_CANDIDATE_COMPLETION'
};
// Password rules used in set/reset/forgot password flow.
export const PASSWORD_RULES = {
  IS_CHARACTER_RULE_SATISFIED: false,
  IS_AT_LEAST_ONE_UPPER_CASE_PRESENT: false,
  IS_AT_LEAST_ONE_LOWER_CASE_PRESENT: false,
  IS_NUMBER_RULE_SATISFIED: false,
  IS_SYMBOL_RULE_SATISFIED: false,
  IS_NO_REPEATING_CHAR_PRESENT: false
}

// Missing country codes
export const COUNTRY_CODES = {
  'United Kingdom of Great Britain and Northern Ireland': 'GB',
  'United States of America': 'US'
}

// Additional Charge Constants  //
export const ADC_ALWAYS_APPROVE = "ALWAYS_APPROVE";
export const ADC_APPROVE_TILL_LIMIT = "APPROVE_TILL_LIMIT";
export const ADC_APPROVAL_REQUIRED = "APPROVAL_REQUIRED";
export const ADC_ALWAYS_REJECT = "ALWAYS_REJECT";
export const ADC_CUSTOM_AMOUNT = "CUSTOM_AMOUNT";
export const ADC_CUSTOM_CONFIG = "CUSTOM_CONFIG";

// Additional Charges Aut0-approval Amount dropdown options
export const AUTO_APPROVAL_AMOUNT = [
  { value: 1000, label: '1,000' },
  { value: 2500, label: '2,500 [RECOMMENDED]' },
  { value: 5000, label: '5,000' },
  { value: ADC_CUSTOM_AMOUNT, label: 'Enter custom amount' },
  { value: ADC_ALWAYS_APPROVE, label: 'Approve any amount' }
];

// ID configs - Use it for comparison with API response
export const CONFIG_ID_TYPES = {
  AADHAAR: 'AADHAAR',
  PAN: 'PAN',
  PASSPORT: 'PASSPORT',
  VOTER_ID: 'VOTER_ID',
  DL: 'DL',
  ANY: 'ANY'
}

// Settings Page Tabs 
export const TAB_COMMUNICATION = 'Communication';
export const TAB_ADDITIONAL_CHARGES = 'Additional Charges';
export const TAB_SECURITY = 'Security';
export const TAB_API = 'API';

// Tabs Mapping for Query Params
export const DEFAULT_TAB_MAPPING = {
  adc: TAB_ADDITIONAL_CHARGES,
  sec: TAB_SECURITY,
  api: TAB_API,
  com: TAB_COMMUNICATION
};

export const PAYMENT_MODEL_TYPE = {
  PREPAID: 'PREPAID',
  POSTPAID: 'POSTPAID'
}
export const ACCESS_LEVEL = {
  COMPANY_ADMIN: 5
}

export const PAYMENT_REQUEST_EXPIRY_IN_DAYS = 30;